import React from 'react';
import AtlasV2KeyMetricsV2Cards from 'src/components/AtlasV2Components/AtlasKeyMetricsV2PageComponents/AtlasKeyMetricsCardsV2';
import { AtlasKeyMetricsGridV2 } from 'src/components/AtlasV2Components/AtlasKeyMetricsV2PageComponents/AtlasKeyMetricsGridV2';
import { useAtlasV2TabTreatmentRedirect } from 'src/components/AtlasV2Components/Hooks/useAtlasV2TabTreatmentRedirect';
import AtlasV2BasicKeyMetricsCards from 'src/components/AtlasV2Components/KeyMetricsComponents/AtlasV2BasicKeyMetricsCards';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { onPrimeMode } from 'src/store/modules/user/selectors';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';

/**
 * The first group of visualizations on the Key MetricV2 page for Atlas
 * @returns a component that renders the legend, key metric cards, and key metric grid
 */
export const AtlasKeyMetricV2PageLayout = () => {
  const mainEntityType = useMainEntityType();
  const { isRedirecting } = useAtlasV2TabTreatmentRedirect();
  if (isRedirecting) return null;
  return (
    <BasePageContainer>
      {onPrimeMode() ? <AtlasV2KeyMetricsV2Cards /> : <AtlasV2BasicKeyMetricsCards />}
      {mainEntityType !== 'product' && <AtlasKeyMetricsGridV2 salesType="retailSales" />}
    </BasePageContainer>
  );
};
